import { css } from "styled-components";

/**
 * Selected-state surface for Betto filter/tab pills.
 *
 * Mirrors the burger-menu active item look: a dark glassy base with a soft
 * blue radial glow (::before) and a faint light overlay border (::after),
 * instead of a flat solid-blue fill. Apply on the `$active`/selected branch.
 *
 * The host element must declare `position: relative; isolation: isolate;
 * overflow: hidden;` so the pseudo-elements anchor and clip correctly.
 */
export const bettoSelectedSurface = css`
	background: #1d2336;
	color: #e5f0fe;
	box-shadow: 0 0 18px rgba(82, 151, 255, 0.2);

	&::before {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		background: radial-gradient(
				ellipse 120% 100% at 0% 50%,
				rgba(82, 151, 255, 0.38) 0%,
				transparent 62%
			),
			radial-gradient(
				ellipse 90% 85% at 100% 30%,
				rgba(82, 151, 255, 0.24) 0%,
				transparent 58%
			);
		pointer-events: none;
		z-index: 0;
	}

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		border: 1px solid #ffffff;
		mix-blend-mode: overlay;
		pointer-events: none;
		z-index: 2;
	}

	span,
	img,
	svg {
		position: relative;
		z-index: 1;
	}

	img {
		filter: drop-shadow(0 0 4px rgba(82, 151, 255, 0.5));
	}
`;
